import styled from 'styled-components';

const TextStepContainer = styled.div`
`;

export default TextStepContainer;
